export default function () {
    const buttons = document.querySelectorAll('.flight-calculator__trip__button');

    if (buttons.length > 0) {
        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                // Remove the "active" class from all buttons
                buttons.forEach(function (btn) {
                    btn.classList.remove('active');
                });

                // Add the "active" class to the clicked button
                button.classList.add('active');
            });
        });
    }
}
